import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getBackofficeOrganizationCreditsQueryKey } from "modules/backoffice/lib/organizations/getBackofficeOrganizationCreditsQuery"
import { getBackofficeOrganizationQueryKey } from "modules/backoffice/lib/organizations/getBackofficeOrganizationQuery"
import { getBackofficeOrganizationsQueryKey } from "modules/backoffice/lib/organizations/getBackofficeOrganizationsQuery"

type Props = {
  id: string
  credits: number
  onSuccess?: () => void
}

export function useAddOrganizationCreditsMutation({ id, credits, onSuccess }: Props) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (organizationId: string) => {
      const response = await axios.post(`/backoffice/organizations/${organizationId}/credits`, {
        credits,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBackofficeOrganizationQueryKey({ id }) })
      queryClient.invalidateQueries({ queryKey: getBackofficeOrganizationsQueryKey() })
      queryClient.invalidateQueries({ queryKey: getBackofficeOrganizationCreditsQueryKey(id) })
      onSuccess?.()
    },
  })
}
